import { useEffect } from 'react';
import axios from 'axios';
import { useCart } from '../context/CartContext';
import { useCustomerAuth } from '../context/CustomerAuthContext';
import { useLanguage } from '../context/LanguageContext';
import { effectivePrice } from '../lib/sale';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Persists a logged-in customer's cart to the backend (debounced) for abandonment reminders.
const CartSync = () => {
  const { cartItems } = useCart();
  const { customer, authHeader } = useCustomerAuth();
  const { getLocalizedText } = useLanguage();

  useEffect(() => {
    if (!customer) return;
    const timer = setTimeout(() => {
      const items = cartItems.map((i) => ({
        name: getLocalizedText(i.name),
        quantity: i.quantity,
        price: effectivePrice(i),
      }));
      const subtotal = items.reduce((s, i) => s + i.price * i.quantity, 0);
      axios
        .post(`${API}/customer/cart`, { items, subtotal, base_url: window.location.origin }, { headers: authHeader() })
        .catch(() => {});
    }, 1200);
    return () => clearTimeout(timer);
  }, [cartItems, customer, getLocalizedText, authHeader]);

  return null;
};

export default CartSync;
